import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ICountry } from 'src/app/entities/countries/state/country.model';
import { RoutePaths } from 'src/app/routes/route-paths.enum';
import {
  LanguageCode,
  LanguageCodes,
} from '@app-shared/enums/language-codes.enum';
import { CountryCode } from '@app-shared/enums/country-codes.enum';
import { UserRole } from '@app-shared/enums/user-roles.enum';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { NGQ_LANGUAGES_TOKEN } from '@app-core/injection-tokens/languages.token';
import { ITranslationLanguage } from '@app-core/interfaces/language.interface';
import { LanguageRepository } from '@app-core/state/language.repository';
import { SessionRepository } from '@app-core/state/session.repository';
import { CountryRepository } from 'src/app/entities/countries/state/country.repository';
import { map } from 'rxjs';

@Component({
  standalone: true,
  selector: 'sandoz-dev-settings',
  templateUrl: './dev-settings.component.html',
  styleUrls: ['./dev-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    RouterModule,

    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatCheckboxModule,
  ],
})
export class DevSettingsComponent {
  protected readonly languagesList =
    inject<ITranslationLanguage[]>(NGQ_LANGUAGES_TOKEN);
  protected readonly availableLanguages = this.languagesList.filter(
    language => language.id !== LanguageCode.CS_CZ,
  );
  protected readonly languageRepo = inject(LanguageRepository);
  protected readonly countryRepo = inject(CountryRepository);
  protected readonly availableCountries$ = this.countryRepo.countries$.pipe(
    map(countries =>
      countries.filter(country => country.country_code !== CountryCode.CZECH),
    ),
  );
  protected readonly sessionRepo = inject(SessionRepository);

  RoutePaths = RoutePaths;
  UserRole = UserRole;

  setLanguage(langID: LanguageCodes): void {
    this.languageRepo.setActiveLanguageByCode(langID);
  }

  changeCountry(country: ICountry): void {
    this.countryRepo.setCountryByCode(country.country_code);

    if (location.pathname.includes('shortage-overview'))
      location.href = location.origin;
  }
}
